export const QFF_SUCCESS_CONTAINER_ID = 'qff_success_container'

export const QFF_FIRST_NAME_KEY = 'first_name'
export const QFF_LAST_NAME_KEY = 'last_name'
export const QFF_EMAIL_KEY = 'email'
export const QFF_REFERENCE_KEY = 'reference'
export const QFF_NUMBER_KEY = 'qff_number'

export const QFF_NUMBER_ERROR_MESSAGE = 'Invalid Qantas Frequent Flyer number'
export const QFF_REFERENCE_ERROR_MESSAGE = 'Invalid Customer Reference'

export const API_POST_URL = '/qff/save/'
export const DEFAULT_RESPONSE_ERROR = 'We encountered an issue while trying to save your details, please try again'



// WEBPACK FOOTER //
// ./containers/QantasFrequentFlyer/constants.js